import { render, staticRenderFns } from "./MailTargetModal.vue?vue&type=template&id=665dc6d0&scoped=true"
import script from "./MailTargetModal.vue?vue&type=script&lang=js"
export * from "./MailTargetModal.vue?vue&type=script&lang=js"
import style0 from "./MailTargetModal.vue?vue&type=style&index=0&id=665dc6d0&prod&lang=css"
import style1 from "./MailTargetModal.vue?vue&type=style&index=1&id=665dc6d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665dc6d0",
  null
  
)

export default component.exports